import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, useParams, To } from "react-router-dom";
import { Loader } from "../../components/loader/Loader";
import { Alert, Pagination, Snackbar } from "@mui/material";
import SelectCustomer from "../../components/createSecondaryOrder/SelectCustomer";
import { ReactComponent as NoProducts } from "../../assets/image/svg/noProductsFound.svg";
import { OutletDetailsType } from "./CreateSecondaryOrderType";
import selectCustomerImage from "../../assets/image/png/selectCustomer.png";
import {
  getFilterOptions,
  getFilterOptionsUnique,
  createQuery,
  getOutletDetails,
  getValidateRequestBody,
  getPieceFilterMapping,
  updateQuantityInCart,
  prepareOrderReqBody,
  getProductUIList,
  updateMultiQtyInCart,
  formatEditedQuantities,
  getOutletDetailsForSecondary,
  isMOQEnabled,
} from "./CreateSecondaryOrderService";
import CatalogueFilters from "../../components/dms_common/CatalogueFilters";
import { OrderType } from "../../types/types";
import {  AggregatedStockData, getAllOutletApprovalData, getSalesData, getSingleOrder, updateInvoice, updateOrder } from "../../services/manageOrderService";
import { ChannelkartNetworkGet, ChannelkartNetworkPost } from "../../services/networkService";
import NewDiscountModal from "../claimsNew/modals/NewDiscountModal";
import { setDiscountModalState } from "../../stateManagement/actions/claims";
import { useDispatch } from "react-redux";
import { setRealTimeStockDataInDb } from "../stocks/RealTimeStock/RealTimeStockUtils";
import FormHeader from "../../components/dms_common/FormHeader";
import Search from "../../components/dms_common/Search";
import CartSummaryFooter from "../../components/dms_common/CartSummaryFooter";
import {
  clearAllDataFromLocalDb,
  getDataFromLocalDb,
  insertDataIntoLocalDB,
} from "../../services/dbService";
import { createCatalogue } from "../../services/catalogueService";
import { Cart, CartProduct, Catalogue, OutletDetails, ProductUI } from "./models";
import dayjs from "dayjs";
import { getConfigData } from "../../services/configurationService";
import CatalogueProductCard from "../../components/createSecondaryOrder/CatalogueProductCard";
import "./CreateSecondaryOrder.css";
import {
  combineTableRowsForCSO,
  combineTableRowsWithStock,
  GenericModal,
  getBatchCodes,
  getGenericModalProps,
  initialGenericModalProps,
} from "../viewOrder/ViewOrderUtils";
import { analytics, logLoadTrace, performance } from "../../../src/firebase";
import { logEvent } from "firebase/analytics";
import { trace, PerformanceTrace } from "firebase/performance";
import CustomGenericModal from "../../components/dms_common/CustomGenericModal";
import ScreenOverlay from "../../components/dms_common/ScreenOverlay";
import { useSelector } from "react-redux";
import { resetSecondaryState, setSecondaryState } from "../../stateManagement/actions/secondaryOrderActions";
import CustomButton from "../../components/dms_common/CustomButton";
import RenderSvg from "../../components/renderSvg/RenderSvg";
import DefaultHeading from "../../components/heading/DefaultHeading";
import { setAllPropAsEmptyArray } from "../manageCoupons/services/services";
import CatalogueFiltersNew from "../../components/dms_common/CatalogueFiltersNew";
import { createScrollHandler, getQuantityType, handleScroll, handleScrollCSO } from "../../components/dms_common/DmsUtils";
import { ReactComponent as ListViewToggle } from "../../assets/image/svg/listViewToggle.svg";
import { ReactComponent as GridViewToggle } from "../../assets/image/svg/gridViewToggle.svg";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import type SimpleBarCore from "simplebar-core";
import { getRouteAndOutletDataMap } from "../SalesReturn/SalesReturnService";

type ProductToggleTabType = "one-click" | "all-products";

export type OneClickCssConfigType = {
  imageBackground?: string,
  lableBackground?: string,
  text?: string,
}

export type OneClickOrderConfigType = {
  isAllowed: boolean,
  mustTry: OneClickCssConfigType,
  recovery: OneClickCssConfigType,
}

const initalizeOneClickConfig: OneClickOrderConfigType = {
  isAllowed: false,
  mustTry:  {
              imageBackground: "",
              lableBackground: "",
              text: "Must Try"
            },
  recovery: {
              imageBackground: "",
              lableBackground: "",
              text: "Recovery"
            }
};

export type ConfigValue = {
  label: string;
  enable: boolean;
  index: number;
}

export interface CreateSecondaryOrderConfig {
  billDate: ConfigValue;
  customer: ConfigValue;
  beats: ConfigValue;
  salesRep: ConfigValue;
  deliveryDate: ConfigValue;
  paymentMethod: ConfigValue;
  shippingAddress: ConfigValue;
  customerChannel: ConfigValue;
  orderTypeLabel: ConfigValue;
};

const defaultConfig: CreateSecondaryOrderConfig = {
  orderTypeLabel: {
    label: "Order Type:",
    enable: true,
    index: 0
    } ,
  customer: {
    label: "Customer:",
    enable: true,
    index: 1
    },
  billDate: {
    label: "Bill Date:",
    enable: true,
    index: 2
  },
  salesRep: {
    label: "Sales Rep:",
    enable: true,
    index: 3
    },
  customerChannel: {
    label: "Cust. Channel:",
    enable: true,
    index: 4
    },
  deliveryDate: {
    label: "Delivery Date:",
    enable: true,
    index: 5
    },
  shippingAddress: {
    label: "Shipping Address:",
    enable: true,
    index: 6
    },
  paymentMethod: {
    label: "Payment Method:",
    enable: true,
    index: 7
    },
  beats: {
    label: "Routes:",
    enable: false,
    index: 1
    },
};

const CreateSecondaryOrder = () => {
  const navigate = useNavigate();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const { orderId } = useParams();
  const query = useQuery();


  let orderStatusInvoiced = query.get("invoice") || false;
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {
    fetchPricingBySalesrep,
    hideMrpLabel = false
  } = ConfigDictionary;

  const [loading, setLoading] = useState<boolean>(fetchPricingBySalesrep && fetchPricingBySalesrep);
  const [addSuggestedQtyState, setAddSuggestedQtyState] = useState<number>(0);
  const disableStockCheck = useRef<boolean>(false);
  const disableSchemeCheck = useRef<boolean>(false);
  const orderTypes = useRef<string[]>(["Direct Sales"]);
  const [selectedButton, setSelectedButton] = useState<ProductToggleTabType>("all-products");
  const [salesReps, setSalesReps] = useState<string[]>([]);
  const [salesRepDisplayNameToLoginIdMapping, setSalesRepDisplayNameToLoginIdMapping] = useState<Record<string, string>>({});
  const [beatDisplayNameToLoginIdMapping, setBeatRepDisplayNameToLoginIdMapping] = useState<Record<string, string>>({});
  const [selectedSalesRep, setSelectedSalesRep] = useState<string>("");
  const [selectedBeat, setSelectedBeat] = useState<string>("");
  const [productLoading, setProductLoading] = useState<boolean>(false);
  const [outletChangeLoading, setOutletChangeLoading] = useState<boolean>(false);
  const [catalogueLoading, setCatalogueLoading] = useState<boolean>(false);
  const [cart, setCart] = useState<Cart>({});
  const [catalogue, setCatalogue] = useState<Catalogue[]>([]);
  const [catalogueOneClick, setCatalogueOneClick] = useState<Catalogue[]>([]);
  const [allProductUIList, setAllProductUIList] = useState<ProductUI[]>([]);
  const [oneClickProductUIList, setOneClickProductUIList] = useState<ProductUI[]>([]);
  const [searchedValue, setSearchedValue] = useState<string>("");
  const [filterOptions, setFilterOptions] = useState<Record<string, string[]>>({});
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentPageOneClick, setCurrentPageOneClick] = useState<number>(1);
  const [totalNumberOfProducts, setTotalNumberOfProducts] = useState(0);
  const [totalNumberOfOneClick, setTotalNumberOfOneClick] = useState(0);
  const [selectedCustomerInfo, setSelectedCustomerInfo] = useState<Record<string, any>>({});
  const [outletDetails, setOutletDetails] = useState<OutletDetails[]>([]);
  const [filteredOutletDetails, setFilteredOutletDetails] = useState<OutletDetails[]>([]);
  const [isOutletDetailsLoaded, setIsOutletDetailsLoaded] = useState<boolean>(false);
  const [selectedSku, setSelectedSku] = useState<any>({});
  const [orderData, setOrderData] = useState<any>({});
  const isOrderDataLoaded = useRef<boolean>(false);
  const [expandForm, setExpandForm] = useState<boolean>(true);
  const [orderUpdateLoading, setOrderUpdateLoading] = useState<boolean>(false);
  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(initialGenericModalProps);
  const [navigateBackOnClose, setNavigateBackOnClose] = useState<boolean>(false);
  const [oneClickOrderConfig, setOneClickOrderConfig] = useState<OneClickOrderConfigType>(initalizeOneClickConfig);
  const [allFilters, setAllFilters] = useState<any>();
  const [isProcessing, setIsProcessing] = useState(false);
  const [newFiltersConfig, setNewFiltersConfig] = useState<string[]>([]);
  const [initialCatalogue, setInitialCatalogue] = useState<Catalogue[]>([]);
  const [noProductFoundIndicator, setNoProductFoundIndicator] = useState<Catalogue[]>([]);
  const [showNoProductFound, setShowNoProductFound] = useState<boolean>(false);
  const [isCounterSaleOrder ,setIsCounterSaleOrder] = useState<boolean>(false);
  const [outletReferenceId, setOutletReferenceId] = useState<string>("");
  const orderFullfillmentTime = useRef<number>(2);
  const createSecondaryOrderConfig = useRef<CreateSecondaryOrderConfig>(defaultConfig);
  const [selectedOutletCode, setSelectedOutletCode] = useState<string>("");
  const isStockDataLoaded = useRef(false);
  const initCalledRef = useRef(false);
  const catalogueLoaded = useRef<boolean>(false);
  const [outletBeatMap, setOutletBeatMap] = useState<Record<string, Set<string>>>({});
  const [beatOutletMap, setBeatOutletMap] = useState<Record<string, Set<string>>>({});
  const [filteredBeatList, setFilteredBeatList] = useState<string[]>([]);
  const [selectedFilters, setSelectedFilters] = useState<Record<string, string>>(()=>{
      const initialFilters: Record<string, string> = {};
      newFiltersConfig.forEach(filter => {
      initialFilters[filter] = "ALL";
  });
  return initialFilters;});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [outletApprovalSent, setOutletApprovalSent] = useState(false)
  const  [showListView, setShowListView] = useState(true);

  const [scrollTop, setScrollTop] = useState<number>(0); 

  const scrollRef = useRef<SimpleBarCore>(null);
  const routeIdNameMappingRef = useRef<any>({});
  const [allowTableScroll, setAllowTableScroll] = useState<boolean>(false);
  const [beatNameMapping, setBeatNameMapping] = useState<Record<string, string>>({});
  const [dontAllowContainerScroll, setDontContainerScroll] = useState(true);

  const dispatch = useDispatch();

  const { createNewOrderState } = useSelector((state: any) => state.secondaryOrder);

  let outletId = query.get("outletId") || createNewOrderState?.outletId || "null";
  let salesRep: string = query.get("salesRep") ?? "null";
  let beat: string = query.get("beat") ?? "null";

  const productsPerPage = ConfigDictionary.otherUnitLabel ? 15 : 18;

  const designation = JSON.parse(localStorage.authContext).user.designation || [];
    
  let enableMOQCheck = false;

  const enableMOQCheckConfig = ConfigDictionary?.enableMOQCheck;
  if (enableMOQCheckConfig?.enable) enableMOQCheck = isMOQEnabled(designation, enableMOQCheckConfig)

  const location = useLocation();
  const locationState: any = location.state as any;

  const { batchIdCatalogue, isEditing } = location.state || {};
  const { aggregateStockSummaryMap, isPartialOrder=false } : {aggregateStockSummaryMap: Map<string, AggregatedStockData>, isPartialOrder: boolean } = location.state || {};

  const handleCheckout = () => {
    if (Object.keys(cart?.[selectedCustomerInfo?.outletCode]?.productsMap ?? {}).length > 0) {
      navigate(`checkout?outletId=` + selectedCustomerInfo?.outletCode + ((fetchPricingBySalesrep && fetchPricingBySalesrep) ? `&salesRep=${selectedSalesRep}&beat=${selectedBeat}` : ''), {
        state: {
          isCounterSaleOrder: isCounterSaleOrder,
          outletReferenceId: outletReferenceId,
          showListView: showListView
        },
      });
    } else {
      const updatedGenericModalProps = getGenericModalProps(
        `positive`,
        `Add items to the cart for proceeding further.`,
        `Continue`,
        ``,
        () => setGenericModalProps(initialGenericModalProps)
      );
      setGenericModalProps(updatedGenericModalProps);
    }
  };

  const handleOrderUpdate = async () => {
    setOrderUpdateLoading(true);
    const outletCart = {
      ...cart?.[selectedCustomerInfo?.outletCode],
      customer: { outletCode: orderData?.outletCode,
        beat: orderData?.beat,
        selectedSalesRep: selectedSalesRep,
      },
    };
    try {

      const products: CartProduct[] = Object.values(outletCart?.productsMap || {});
      let addedSkus: string[] = [];
      const existingBatchCodes = orderData?.orderDetails.map((s: any) => s?.batchCode) ?? [];

      addedSkus = products
        .filter((product) => !existingBatchCodes.includes(product.batchCode))
        .map((product) => product.batchCode) ?? [];

      let addedCases = 0;
      let addedPieces = 0;
      let addedOtherUnits = 0;

      products?.forEach((s: CartProduct) => {
        if (addedSkus?.includes(s?.batchCode)) {
          addedCases += s?.caseQuantity || 0;
          addedPieces += s?.pieceQuantity || 0;
          addedOtherUnits += s?.otherUnitQuantity || 0;
        }
      });

      const requestBody: Record<any, any> = getValidateRequestBody(outletCart, orderData, true) ?? {}

      // this runs when we are updating an invoice
      if(orderStatusInvoiced && requestBody) {
        requestBody["salesDetails"]  = requestBody?.["orderDetails"]
        requestBody["invoiceNumber"] = orderData?.invoiceNumber
        delete requestBody?.["orderDetails"]
        delete requestBody?.["referenceNumber"];

        let response = await updateInvoice(requestBody)
        logEvent(analytics, "secondary_invoice_edited", {
          "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
          "order_id": orderData?.id,
          "edited_skus": 0,
          "edited_qty": 0,
          "total_discount": response?.data?.feature?.[0]?.discountInfo?.[0]?.discount,
          "added_skus": addedSkus,
          "added_qty": formatEditedQuantities(addedCases, addedPieces, addedOtherUnits),
        });
        await resetCart()
        navigate(`/dashboard/sale/manageInvoices/viewInvoice/${orderId}` as To, {
          state: {
            isEditing: isEditing,
          }
        })

        // this runs when we are updating an order
      } else {

        const response = await ChannelkartNetworkPost(
          "/orders/validate?transformerOut=orderDetailSplit",
          requestBody
        );
        if (response?.status === 200 || response?.status === 201) {
          const validateResponse = response?.data?.feature?.[0];
          delete validateResponse["creationTime"];
          const orderPutPayload = prepareOrderReqBody(validateResponse, OrderType.SECONDARY);
          await updateOrder(orderPutPayload, orderData?.orderNumber);
          logEvent(analytics, "secondary_order_edited", {
            "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
            "order_id": orderData?.id ?? null,
            "edited_skus": 0, // Assuming this is fixed to 0, as per your original code
            "edited_qty": 0, // Assuming this is fixed to 0, as per your original code
            "total_discount": validateResponse?.discountInfo?.[0]?.discount ?? null,
            "added_skus": addedSkus ?? 0, // Default to 0 if `addedSkus` is undefined
            "added_qty": formatEditedQuantities(addedCases, addedPieces, addedOtherUnits) ?? 0, // Default to 0 if the function call returns undefined
          });


          await resetCart()
          navigate(-1);
        } else {
          console.error("error");
        }    
      }
    } catch (e) {
      setGenericModalProps(getGenericModalProps("error", "Error while updating order"));
      console.log(e);
    } finally {
      setOrderUpdateLoading(false);
    }
  };

  const populateCart = async (data: any) => {
    const responseCatalogue = await getDataFromLocalDb("Catalogue");
    data?.orderDetails?.forEach((item: any) => {
      const { batchCode, caseQuantity, pieceQuantity, otherUnitQuantity } = item;
      updateMultiQtyInCart(
        batchCode,
        {
          caseQuantity: caseQuantity,
          otherUnitQuantity: otherUnitQuantity,
          pieceQuantity: pieceQuantity,
        },
        { outletCode: data?.outletCode },
        responseCatalogue?.data,
        setCart
      );
    });
  };

  const getOrderDetails = async (orderId: string) => {
    try {
      let res, data

      if (orderStatusInvoiced) {
        res = await getSalesData(orderId);
        data = {
          ...res?.data?.features?.[0],
          orderDetails: res?.data?.features?.[0]?.salesDetails,
        };
        if (batchIdCatalogue) {
          data.orderDetails = combineTableRowsForCSO(data?.orderDetails)
        }
        data?.orderDetails?.forEach((item: any) => {
          const { initialCaseQuantity, initialPieceQuantity, initialOtherUnitQuantity } =
            item || {};
          item.caseQuantity = initialCaseQuantity;
          item.pieceQuantity = initialPieceQuantity;
          item.otherUnitQuantity = initialOtherUnitQuantity;
        })
      }
      else {
        res = await getSingleOrder(orderId);
        data = res?.data?.features?.[0]
      }

      const validOrderData = JSON.parse(JSON.stringify(data))
      const validOrderDetails = validOrderData?.orderDetails?.filter((sku: any) => sku?.type !== "freeItem")
      validOrderData.orderDetails = validOrderDetails

      if (res.status === 200) {
        if(fetchPricingBySalesrep && fetchPricingBySalesrep && orderId) {
          setSelectedSalesRep(validOrderData?.["loginId"]);
          setSelectedBeat(validOrderData?.["beat"])
        }
        const outletCode = data?.outletCode;
        setOrderData(validOrderData);
        setSelectedCustomerInfo({
          ...selectedCustomerInfo,
          ...(fetchPricingBySalesrep && fetchPricingBySalesrep && orderId && {
            selectedSalesRep: validOrderData?.["loginId"],
            beat: validOrderData?.["beat"]
          }),
          outletCode,
        });
      }
    } catch (err: any) {
      console.error(err);
        setGenericModalProps(
          getGenericModalProps("error", `Order with Id ${orderId} not found`)
        );
    }
  };

  const resetCart = async () => {
    setAddSuggestedQtyState(0);
    const res = await getDataFromLocalDb("Cart");
    const updatedCart = await JSON.parse(JSON.stringify(res?.data?.[0]?.data ?? {}));
    delete updatedCart?.[outletId];

    setCart(updatedCart);
    insertDataIntoLocalDB("Cart", [{ id: 1, data: updatedCart }]);
  };

  const fetchRequiredConfigs = async () => {
    try {
      const dbResult = await getDataFromLocalDb("RouteNameIdMapping");
      routeIdNameMappingRef.current = dbResult?.data?.[0]?.data ?? {};
      const orderFulfillmentConfig = await getConfigData(
        "order_configuration",
        "orderFulfillmentTime"
      );
      const cso = await getConfigData("dms_configuration", "createSecondaryOrderConfig");
      const res3 = await getConfigData("dms_configuration", "disableStockCheck");
      const res4 = await getConfigData("dms_configuration", "disableSchemeCheck");
      const res5 = await getConfigData("dms_configuration", "orderTypes");
      const res8 = await getConfigData("order_configuration","filterProductAttributes")
      setNewFiltersConfig(res8[0]?.configValue ?? []);
      createSecondaryOrderConfig.current = cso[0]?.configValue ?? defaultConfig;
      disableStockCheck.current = res3[0]?.configValue ?? false;
      disableSchemeCheck.current = res4[0]?.configValue ?? false;
      orderTypes.current = res5[0]?.configValue?.split(",") ?? ["Direct Sales"];
      let isOneClickOrderAllowedL = (ConfigDictionary?.oneClickOrder === "true" || ConfigDictionary?.oneClickOrder === true);
      setSelectedButton((isOneClickOrderAllowedL && !orderId) ? "one-click" : "all-products");
      orderFullfillmentTime.current = orderFulfillmentConfig[0]?.configValue ?? 2;
      if(isOneClickOrderAllowedL) {
        const orderOneClickCSSConfig = await getConfigData("order_configuration", "oneClickOrderCSS");
        const oneClickOrderConfig: OneClickOrderConfigType = {
          isAllowed: true,
          mustTry: {
                imageBackground: orderOneClickCSSConfig[0]?.configValue?.["must-try"]?.imageBackground ?? "#DEF5F3",
                lableBackground: orderOneClickCSSConfig[0]?.configValue?.["must-try"]?.lableBackground ?? "#34c2b2",
                text: orderOneClickCSSConfig[0]?.configValue?.["must-try"]?.text ?? "Must Try"
              },
          recovery: {
                imageBackground: orderOneClickCSSConfig[0]?.configValue?.["recovery"]?.imageBackground ?? "#F9DFE1",
                lableBackground: orderOneClickCSSConfig[0]?.configValue?.["recovery"]?.lableBackground ?? "#C44C36",
                text: orderOneClickCSSConfig[0]?.configValue?.["recovery"]?.text ?? "Recovery"
              }
        };

        setOneClickOrderConfig(oneClickOrderConfig);
      }
    } catch (e) {
      console.error("Error while fetching configs", e);
      setGenericModalProps(
        getGenericModalProps("error", "Error while fetching configs")
      );
    }
  };

  const updateSelectedCustomer = async () => {
    const cartResponse = await getDataFromLocalDb("Cart");
    const customerDataInCartDb = cartResponse?.data?.[0]?.data?.[outletId]?.customer;
    const customerDataPresent = Boolean(Object.keys(customerDataInCartDb ?? {})?.length);

    if (cartResponse.total > 0) {
      setCart(cartResponse?.data?.[0]?.data);
    }

    const newQuery = new URLSearchParams(window.location.search);
    if(newQuery.has("salesRep")) {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete("salesRep");
      setSelectedSalesRep(salesRep);
      window.history.replaceState(window.history.state, "", currentUrl.toString());
      salesRep = "null";
    }
    if(!orderId && outletId !== "null") {
      setSelectedCustomerInfo(
        (customerDataPresent && !orderId && ((fetchPricingBySalesrep && fetchPricingBySalesrep) ? selectedSalesRep?.length !== 0 : true ) && (!(fetchPricingBySalesrep && fetchPricingBySalesrep) || isOutletDetailsLoaded))
          ? customerDataInCartDb
          : {
              outletCode: "",
              beat: "",
              salesType: "Direct Sales",
              billDate: dayjs().format("DD/MM/YY"),
              deliveryDate: dayjs().add(orderFullfillmentTime.current, "day").format("DD/MM/YY"),
            }
      );
    }

    if (outletId !== "null") {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete("outletId");
      setSelectedOutletCode?.(outletId);
      window.history.replaceState(window.history.state, "", currentUrl.toString());
      outletId = "null";
    }
    if(beat !== "null") {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete("beat");
      setSelectedBeat(beat);
      window.history.replaceState(window.history.state, "", currentUrl.toString());
      beat = "null";
    }

  }

  useEffect(() => {
    if(noProductFoundIndicator && selectedButton === "all-products" && isOutletDetailsLoaded){
      setShowNoProductFound(true)
    }else {
      setShowNoProductFound(false)
    }
  },[searchedValue,selectedButton])

    const getAndSetData = async () => {
      if(fetchPricingBySalesrep && fetchPricingBySalesrep && ((salesReps?.length === 0) && !orderId)) return;
      setLoading(!(fetchPricingBySalesrep && fetchPricingBySalesrep && !orderId));
      try {
        if (locationState?.showListView !== undefined) {
        setShowListView(locationState.showListView);
      }
        if (orderId) {
          if(!isOrderDataLoaded.current) await getOrderDetails(orderId);
          isOrderDataLoaded.current = true;
          resetCart();
          if(fetchPricingBySalesrep && fetchPricingBySalesrep && selectedSalesRep?.length === 0) return;
        } else {
          let outletsListFinal;
          let responseOutletDetails: OutletDetails[];
          const loginId = JSON.parse(localStorage.authContext)?.user?.loginId;
          if(fetchPricingBySalesrep && fetchPricingBySalesrep && (((salesReps?.length === 0) && !orderId) || selectedSalesRep?.length ===0)){
            return;
          } else if(fetchPricingBySalesrep && fetchPricingBySalesrep && !orderId && selectedSalesRep?.length !== 0 ){
            setOutletChangeLoading(true);
            responseOutletDetails = await getOutletDetailsForSecondary(selectedSalesRep);
            setOutletChangeLoading(false);
          } else {
            responseOutletDetails = await getOutletDetails();
          }

          const outletsList = responseOutletDetails.filter(
            (outlet) => outlet.outletCode !== loginId
          );
          outletsListFinal = outletsList.filter((outlet) => {
            const isActive = (outlet.activeStatus?.toUpperCase() === "ACTIVE" || outlet.approvalStatus?.toUpperCase() === "APPROVED" );
            const isInactiveAndPendingApproval =
              !outlet.lastOrderDate &&
              outlet.approvalStatus?.toUpperCase() === "PENDING"
            outlet._isInactiveAndPendingApproval = isInactiveAndPendingApproval;
            return isActive || isInactiveAndPendingApproval;
          }).sort((a, b) => {
            // Sort so that outlets with _isInactiveAndPendingApproval === true come first
            return (b._isInactiveAndPendingApproval ? 1 : 0) - (a._isInactiveAndPendingApproval ? 1 : 0);
          });;
          

         const filterOutletsBasedOnCurrentDesignation = await getConfigData("dms_configuration","filterOutletsBasedOnCurrentDesignation");
         const filterOutletsBasedOnCurrentDesignationValue = filterOutletsBasedOnCurrentDesignation[0]?.configValue ?? false;
         
          if(filterOutletsBasedOnCurrentDesignationValue) {
            
            const currentUserData = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user;
            const designations: string[] = currentUserData?.designation ?? [];

            if(designations.includes("bigdistributor")) {
              outletsListFinal = outletsList.filter(obj => 
                obj.outletType &&
                ((obj.outletType.toLowerCase() === "subdistributor") || (obj.outletType.toLowerCase() === "retailer"))
              );
            } else if (designations.includes("subdistributor")) {
              outletsListFinal = outletsList.filter(obj => 
                obj.outletType &&
                (obj.outletType.toLowerCase() === "subdretailer")
              );
            }
        }

          const outletToRoutesMap: Record<string, Set<string>> = {};
          const routeToOutletsMap: Record<string, Set<string>> = {};

          // Create mapping from loginId to name and display names
          const beatNameMapping: Record<string, string> = {};
          const displayNameToBeatMapping: Record<string, string> = {};
          let routeIdNameMap: Record<string, any> = routeIdNameMappingRef.current;

          outletsListFinal.forEach(({ beat, outletCode }) => {
              if (!beat || !outletCode) return;

              const beats = beat.split(',').map(b => b.trim());

              // Map outletCode => beats
              outletToRoutesMap[outletCode] = new Set(beats);

              // Map each beat => outletCode
              beats.forEach(b => {
                  if (!routeToOutletsMap[b]) {
                      routeToOutletsMap[b] = new Set();
                  }
                  routeToOutletsMap[b].add(outletCode);
              });
          });
          
          // Check for duplicate names and create display names
          // const allNames = Object.values(routeIdNameMap);
          const beatDisplayNames: string[] = [];
          let routeIdSet = Object.keys(routeToOutletsMap);

          const filter1CountMap: Record<string, number> = {};

          Object.values(routeIdNameMap)
            .filter(ri => routeIdSet.includes(ri?.entityId))
            ?.forEach((node: any) => {
              const key = node?.filter1;
              if (key != null) {
                filter1CountMap[key] = (filter1CountMap[key] || 0) + 1;
              }
            });

          Object.values(routeIdNameMap).filter(ri => routeIdSet.includes(ri?.entityId))?.forEach((node: any) => {
              const isDuplicateName = (filter1CountMap[node?.filter1 ?? ""] ?? 0) > 1;
              const displayName = isDuplicateName
                  ? (node?.filter1 ? `${node?.filter1}-${node?.entityId}` : node?.entityId)
                  : (node?.filter1 ?? node?.entityId);

              beatDisplayNames.push(displayName);
              displayNameToBeatMapping[displayName] = node?.entityId;
              beatNameMapping[node?.entityId] = displayName;
          });

          setBeatNameMapping(beatNameMapping);
          setOutletBeatMap(outletToRoutesMap);
          setBeatOutletMap(routeToOutletsMap);
          setFilteredBeatList(beatDisplayNames);
          setBeatRepDisplayNameToLoginIdMapping(displayNameToBeatMapping);
          setOutletDetails(outletsListFinal);
          setFilteredOutletDetails(outletsListFinal);
          setIsOutletDetailsLoaded(true);
        }
        setLoading(false);
      } catch (error) {
        setGenericModalProps(
          getGenericModalProps("error", "Error while fetching data")
        );
        setLoading(false);
        console.error(error);
      } 
    };

    const initialize = async() => {
      await fetchRequiredConfigs();
      await fetchApprovalData();
      await updateSelectedCustomer();
      if (!isStockDataLoaded.current && !orderId) {
          await setRealTimeStockDataInDb("",getQuantityType());
          isStockDataLoaded.current = true; // lock immediately
      }
      setSearchedValue("");
    }

    const fetchApprovalData = async() => {
      if(!orderId && orderTypes.current.includes("Counter Sales")){
        const res = await getAllOutletApprovalData()
              
        const existingOutletList = await getDataFromLocalDb("OutletList");

        if (Array.isArray(existingOutletList?.data) && Array.isArray(res)) {
          const approvalMap = new Map(
            res.map((outlet: any) => [outlet.reference_id, outlet.status])
          );
          existingOutletList.data = existingOutletList.data.map((outlet: any) => {
            if (approvalMap.has(outlet.id)) {
              return {
                ...outlet,
                approvalStatus: approvalMap.get(outlet.id)
              };
            }
            return outlet;
          });
          await clearAllDataFromLocalDb("OutletList");
          await insertDataIntoLocalDB("OutletList", existingOutletList.data);
        }
      }
    }
    const init = async() => {
      await Promise.allSettled([initialize()]);
    }

  useEffect(() => {
    if (!initCalledRef.current) {
      initCalledRef.current = true;
      logLoadTrace(init, "create_secondary_order_page_load_time");
    }

    return () => {
      if(!window.location.pathname?.includes("createSecondaryOrder")){
        dispatch(resetSecondaryState())
      }
      if (orderId) {
        setExpandForm(true)
        resetCart();
      }
    };
  }, []);

  useEffect(() => {
      getAndSetData();
  }, [orderId, selectedSalesRep, salesReps, isOutletDetailsLoaded]);

  // useEffect(() => {
  //   const fetchOutletDetails = async () => {
  //     try {
  //       const loginId = JSON.parse(localStorage.authContext)?.user?.loginId;

  //       const responseOutletDetails = await getOutletDetailsForSecondary();
  //       const responseAllOutletApprovalData = await getAllOutletApprovalData();

  //       const outletsList = responseOutletDetails.filter(
  //         (outlet) => outlet.outletCode !== loginId
  //       );
  //       const outletListNew = outletsList.filter((outlet) => {
  //         const isActive = outlet.activeStatus === "active";

  //         const isInactiveAndPendingApproval =
  //           outlet.activeStatus === "inactive" && //outlet is inactive
  //           !outlet.lastOrderDate && //has no order placed with it
  //           responseAllOutletApprovalData?.data?.features?.find(
  //             (feature: { referenceId: string; status: string }) =>
  //               feature.referenceId === outlet.id
  //           )?.status === "PENDING"; //its approval is pending
  //           outlet._isInactiveAndPendingApproval = isInactiveAndPendingApproval;
  //         return isActive || isInactiveAndPendingApproval;
  //       }).sort((a, b) => {
  //         // Sort so that outlets with _isInactiveAndPendingApproval === true come first
  //         return (b._isInactiveAndPendingApproval ? 1 : 0) - (a._isInactiveAndPendingApproval ? 1 : 0);
  //       });;;

  //       setOutletDetails(outletListNew);
  //     } catch (error) {
  //       console.error("Error fetching outlet details:", error);
  //       // Optionally handle error state here
  //     }
  //   };
  // fetchOutletDetails();
  // if (selectedCustomerInfo?.activeStatus === "inactive") setSnackbarOpen(true)
  // }, [selectedCustomerInfo?.outletCode]);
  useEffect(() => {
    if (selectedCustomerInfo?.activeStatus === "inactive" && filteredOutletDetails?.length > 0) setSnackbarOpen(true)
  }, [selectedCustomerInfo?.outletCode])

  useEffect(() => {
    if (outletApprovalSent) setGenericModalProps(getGenericModalProps("success", "Outlet Approval sent successfully"))
  }, [outletApprovalSent])

  useEffect(() => {
    // Wait until orderData is loaded when orderId is present
    if ((orderId && !isOrderDataLoaded.current) || !initCalledRef.current) return;
    if(fetchPricingBySalesrep && fetchPricingBySalesrep && (!selectedSalesRep || selectedSalesRep?.length === 0 )) return;
    setOutletChangeLoading(true);
    const updateProductsList = async () => {
      if(fetchPricingBySalesrep && fetchPricingBySalesrep && (!selectedCustomerInfo?.outletCode || selectedCustomerInfo?.outletCode?.length === 0) && (!selectedCustomerInfo?.beat || selectedCustomerInfo?.beat?.length === 0)){
        await clearAllDataFromLocalDb("Catalogue");
        setCatalogueLoading(false);
        return;
      }
      try {
        setCatalogueLoading(true);
        if (selectedCustomerInfo?.outletCode) {
          // await clearAllDataFromLocalDb("Catalogue");

          // this if condition is for checking if we have pricing for all sku that are present in the order or not
          let orderedBatchCodes: string | string[] = [];
          if(orderId) {
             orderedBatchCodes = getBatchCodes(orderData?.orderDetails
                ?.map((item: any) => item?.type !== "freeItem" ? item : null)
                ?.filter(Boolean)
            ) ?? "";
            orderedBatchCodes = orderedBatchCodes?.split(",") ?? []
          }
          if(!isStockDataLoaded.current) {
            await setRealTimeStockDataInDb("", getQuantityType(), orderData?.supplier);
            isStockDataLoaded.current = true;
          }
          const catalogue = await createCatalogue(
            OrderType.SECONDARY,
            selectedCustomerInfo?.outletCode,
            !disableSchemeCheck.current,
            orderedBatchCodes,
            (fetchPricingBySalesrep && fetchPricingBySalesrep) ? selectedSalesRep : selectedCustomerInfo?.salesRep,
            oneClickOrderConfig.isAllowed && !orderId,
            undefined,
            orderId ? orderData?.supplier : undefined
          );
          catalogueLoaded.current = true;
          if (catalogue && Array.isArray(catalogue) && catalogue?.length == 0) {
            setGenericModalProps(
              getGenericModalProps("error", "Some items in this order could not be edited due to missing/incorrect pricing data. Please update the data in the MDM & Integration Page.")
            );
            setNavigateBackOnClose(true)
            return 
          }
          const responseFilterOptions = getFilterOptionsUnique(catalogue,newFiltersConfig as (keyof Catalogue)[]);
          if (responseFilterOptions) {
            setFilterOptions(responseFilterOptions);
          }
          if (orderId) {
            await populateCart(orderData);
          }
          await createProductsList();
        }
      } catch (err: any) {
        catalogueLoaded.current = true;
        console.error("Error while refreshing the products list: ", err);
        if (err?.message === "pricing") {
          setGenericModalProps(
            getGenericModalProps("error", "⚠️  Unable to fetch pricing details. Please try again later.",
              "Ok",
              ``,
              () => {
                setGenericModalProps(initialGenericModalProps)
              }
            ));
        } else if (err?.message === "offers") {
          setGenericModalProps(
            getGenericModalProps("error", "⚠️  Unable to load offer details. Please refresh or try again.",
              "Ok",
              ``,
              () => {
                setGenericModalProps(initialGenericModalProps)
              }
            )
          );
        } else {
          setGenericModalProps(
            getGenericModalProps("error", `Order with Id ${orderId} not found`)
          );
        }
      } finally {
        setCatalogueLoading(false);
      }
    };
    if(orderId) {
      logLoadTrace(updateProductsList,"secondary_order_edit_page_load_time");
    } else {
      updateProductsList()
    }
  }, [selectedCustomerInfo?.outletCode, selectedCustomerInfo?.outletCode, orderId, isOrderDataLoaded, allFilters, selectedSalesRep]);

  useEffect(() => {
    const validOutletCode =
      typeof selectedCustomerInfo?.outletCode === `string` &&
      selectedCustomerInfo?.outletCode != `null` && selectedCustomerInfo?.outletCode?.trim()?.length !== 0;
    
    if(validOutletCode && !orderId) {
      dispatch(
        setSecondaryState(createNewOrderState, {
          ...createNewOrderState,
          outletId: selectedCustomerInfo?.outletCode,
        })
      );
    }

    const updateCustomerData = async () => {
      const outletCode = selectedCustomerInfo?.outletCode;
      const res = await getDataFromLocalDb("Cart");
      const localDbCartData = res?.data?.[0]?.data || {};
      const addSuggestedQtyStateDb = localDbCartData?.[outletCode]?.addSuggestedQtyState ?? 0;
      setAddSuggestedQtyState(addSuggestedQtyStateDb);
      setCart({
        ...cart,
        [outletCode]: {
          ...cart[outletCode],
          customer: selectedCustomerInfo,
        },
      });
      await insertDataIntoLocalDB("Cart", [
        {
          id: 1,
          data: {
            ...localDbCartData,
            [outletCode]: {
              ...localDbCartData[outletCode],
              customer: selectedCustomerInfo,
            },
          },
        },
      ]);
    };

    updateCustomerData();
  }, [selectedCustomerInfo]);

  useEffect(() => {
    if (selectedCustomerInfo?.outletCode) {
      if(fetchPricingBySalesrep && fetchPricingBySalesrep && (!selectedSalesRep || selectedSalesRep?.length === 0 )) return;
      createProductsList();
    }
  }, [currentPage, currentPageOneClick, searchedValue, selectedFilters, orderId, selectedSalesRep, fetchPricingBySalesrep, showListView]);

  useEffect(() => {
    const setInitialFilters = () => {
        if (newFiltersConfig.length > 0 && Object.keys(selectedFilters).length === 0) {
            const initialFilters: Record<string, string> = {};
            newFiltersConfig.forEach(filter => {
                initialFilters[filter] = "ALL";
            });
            setSelectedFilters(initialFilters);
        }
    };

    if (!orderId) {
        logEvent(analytics, "secondary_order_initiated", {
            "distributor_id": JSON.parse(localStorage.authContext).user.loginId
        });
    }
    setInitialFilters();
}, [newFiltersConfig, orderId,initialCatalogue]);
  const createProductsList = async () => {
    if(!catalogueLoaded.current) return;
    setProductLoading(true);
    try {
      const query = (selectedButton === "one-click" && !orderId) ? createQuery(undefined, {"isRecommended": "true"}) : createQuery(searchedValue, selectedFilters);
      let pageNo: number | undefined = 0;
      if((selectedButton === "one-click" && !orderId) || showListView) {
        pageNo = undefined;
      } else {
        pageNo = searchedValue ? 1 : currentPage;
      }
      const responseCatalogue = await getDataFromLocalDb(
        "Catalogue",
        query,
        pageNo,
        productsPerPage,
        true
      );
      setNoProductFoundIndicator(responseCatalogue?.data)
      const responseCatalogueInitialSet = await getDataFromLocalDb(
        "Catalogue",
        // query,
        createQuery(undefined, {}),
        undefined,
        productsPerPage,
        true
      );
      setInitialCatalogue(responseCatalogueInitialSet?.data)
      if(selectedButton === "one-click" && !orderId) {
        setCatalogueOneClick(responseCatalogue?.data);
      } else {
        setCatalogue(responseCatalogue?.data);
      }

      const res = await getDataFromLocalDb("Cart");
      const cart = res?.data?.[0]?.data ?? {};

      const cartProductsMap = cart?.[selectedCustomerInfo?.outletCode]?.productsMap ?? {};
      const allProductUIList: ProductUI[] = getProductUIList(responseCatalogue, cartProductsMap, "PENDING" === orderData?.status?.toUpperCase(), aggregateStockSummaryMap);

      if(selectedButton === "one-click" && !orderId) {
        setOneClickProductUIList(allProductUIList);
        setTotalNumberOfOneClick(responseCatalogue?.total);
      } else {
        setTotalNumberOfProducts(responseCatalogue?.total);
        setAllProductUIList(allProductUIList);
      }

      setProductLoading(false);
    } catch (error) {
      setProductLoading(false);
    }
  };


  const updateFilterSelection = (filterType: string, option: string, rowIndex: number) => {
    setCurrentPage(1);

    setSelectedFilters((prevSelectedOptions) => {
        const allFilterTypes = newFiltersConfig; // Array of filter types in order
        const currentIndex = allFilterTypes.indexOf(filterType);
        const newFilters = { ...prevSelectedOptions };

        // Set the current filter selection
        newFilters[filterType] = option;

        // If option is not "ALL", reset only subsequent filters to "ALL"
        if (option !== "ALL") {
            for (let i = currentIndex + 1; i < allFilterTypes.length; i++) {
                newFilters[allFilterTypes[i]] = "ALL";
            }
        }
        // If option is "ALL", reset current and subsequent filters to "ALL"
        else {
            for (let i = currentIndex; i < allFilterTypes.length; i++) {
                newFilters[allFilterTypes[i]] = "ALL";
            }
        }


        // Update filter options for subsequent filters only
        updateSubsequentFilterOptions(newFilters, currentIndex);

        return newFilters;
    });

    logEvent(analytics, "secondary_create_order_filter", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "filter_type": filterType
    });
};

// New helper function to update filter options only for subsequent filters
const updateSubsequentFilterOptions = (currentFilters: Record<string, string>, currentIndex: number) => {
  const allFilterTypes = newFiltersConfig;

  // Filter the catalogue based on selections up to and including the current filter
  const filtersUpToCurrent = Object.fromEntries(
      allFilterTypes
          .slice(0, currentIndex + 1)
          .map(key => [key, currentFilters[key] || "ALL"])
  );

  const filteredCatalogue = initialCatalogue.filter((item: Catalogue) => {
      return Object.entries(filtersUpToCurrent).every(([key, value]) => {
          if (value === "ALL") return true;
          return item[key as keyof Catalogue] === value;
      });
  });

  // Generate new filter options for all filters, but only update subsequent ones
  const newFilterOptions = getFilterOptionsUnique(filteredCatalogue, newFiltersConfig as (keyof Catalogue)[]);
  
  setFilterOptions((prevFilterOptions) => {
      const updatedOptions = { ...prevFilterOptions };
      // Only update options for filters below the current one
      for (let i = currentIndex + 1; i < allFilterTypes.length; i++) {
          updatedOptions[allFilterTypes[i]] = newFilterOptions[allFilterTypes[i]] || [];
      }
      return updatedOptions;
  });
};

  const handleClickViewSkuDetails = (product: ProductUI) => {
    setSelectedSku(product);
    dispatch(setDiscountModalState(true));
  };

  const getSkuData = () => {
    return {
      productUI: selectedSku,
      orderDetails: [
        {
          extendedAttributes: { blobKey: selectedSku?.imageUrl },
          skuDescription: selectedSku?.name,
          batchCode: selectedSku?.batchCode,
          caseQuantity: selectedSku?.availableCaseQty,
          pieceQuantity: selectedSku?.availablePieceQty,
          otherUnitQuantity: selectedSku?.availableOtherQty,
          discountInfo: selectedSku?.schemes?.map((scheme: any) => {
            return { ...scheme, discountInfo: scheme?.schemeDescription };
          }),
          mrp: selectedSku?.mrp,
          caseMrp: selectedSku?.caseMrp,
          pieceSize: getPieceFilterMapping(selectedSku?.pieceSize?.toString()),
          productInfo: { skuDescription: selectedSku?.name ?? "" }
        },
      ],
    };
  };

  useEffect(() => {
    const idk = async() => {
      const cartProducts = cart?.[selectedCustomerInfo?.outletCode]?.productsMap ?? {};
      let updateAddState = addSuggestedQtyState === 1;
      let list = (selectedButton === "one-click" ? oneClickProductUIList : allProductUIList);
      for (const product of list) {
        if(product.isRecommended && ((product.suggestedCaseQuantity + product.suggestedQuantity + product.suggestedOtherQuantity) > 0)) {
          const batchProduct = cartProducts[product.batchCode] ?? undefined;
          if(batchProduct) {
            if (
              Number(batchProduct.caseQuantity) < product?.suggestedCaseQuantity ||
              Number(batchProduct.pieceQuantity) < product?.suggestedQuantity ||
              Number(batchProduct.otherUnitQuantity) < product?.suggestedOtherQuantity
            ) {
              updateAddState = false;
              break;
            } else if (
              Number(batchProduct.caseQuantity) >= product?.suggestedCaseQuantity &&
              Number(batchProduct.pieceQuantity) >= product?.suggestedQuantity &&
              Number(batchProduct.otherUnitQuantity) >= product?.suggestedOtherQuantity
            ) {
              updateAddState = true;
            }
          } else {
            updateAddState = false;
            break;
          }
        }
      }

      setAddSuggestedQtyState(updateAddState ? 1 : 0);
    }
    idk()
 }, [cart])
  const handleSnackbarClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };
  const updateAddSuggetedStateData = async () => {
      const outletCode = selectedCustomerInfo?.outletCode;
      const res = await getDataFromLocalDb("Cart");
      const localDbCartData = res?.data?.[0]?.data || {};
      await insertDataIntoLocalDB("Cart", [
        {
          id: 1,
          data: {
            ...localDbCartData,
            [outletCode]: {
              ...localDbCartData[outletCode],
              addSuggestedQtyState: addSuggestedQtyState
            },
          },
        },
      ]);
  };
  
  useEffect(() => {
    return () => {
      updateAddSuggetedStateData();
    };
  }, [addSuggestedQtyState, selectedCustomerInfo?.outletCode]);

  const cartProducts = cart?.[selectedCustomerInfo?.outletCode]?.productsMap ?? {};

  useEffect(() => {
    const fetchAndSaveSalesReps = async () => {
      if(orderId) return;
      if(!fetchPricingBySalesrep) return;
      try {
        if(!orderId) {
          setLoading(true);
        }
        const response = await ChannelkartNetworkGet(
          "/users/mapped/hierarchy?filter=activeStatus:active and designation[in]:[salesman]&size=10000&source=portal"
        );
        
        // Create mapping from loginId to name and display names
        const salesRepMapping: Record<string, string> = {};
        const displayNameToLoginIdMapping: Record<string, string> = {};
        response?.data?.features?.forEach((node: any) => {
          if (node?.loginId && node?.name) {
            salesRepMapping[node.loginId] = node.name;
          }
        });
        
        // Check for duplicate names and create display names
        const allNames = Object.values(salesRepMapping);
        const salesRepDisplayNames: string[] = [];
        
        response?.data?.features?.forEach((node: any) => {
          if (node?.loginId && node?.name) {
            const isDuplicateName = allNames.filter((name: string) => name === node.name).length > 1;
            const displayName = isDuplicateName ? `${node.name}-${node.loginId}` : node.name;
            salesRepDisplayNames.push(displayName);
            displayNameToLoginIdMapping[displayName] = node.loginId;
          }
        });
        
        // Store the mapping in state for later use
        setSalesRepDisplayNameToLoginIdMapping(displayNameToLoginIdMapping);
        setSalesReps(salesRepDisplayNames);
      } catch (error) {
        console.error(error);
        // optionally set an error state
      } finally {
        if(!orderId) {
          setLoading(false);
        }
      }
    };

    fetchAndSaveSalesReps();
  }, [fetchPricingBySalesrep]);

  useEffect(() => {
      createProductsList();
  }, [selectedButton])

  const handleToggleSelectedButton = async (type: ProductToggleTabType) => {
    if(selectedButton !== type) {
      setCurrentPage(1);
      setCurrentPageOneClick(1);
      setSearchedValue("");
      // Reset filters only when switching from "one-click" to "all-products"
    if (selectedButton === "one-click" && type === "all-products") {
      const initialFilters: Record<string, string> = {};
      newFiltersConfig.forEach(filter => {
        initialFilters[filter] = "ALL";
      });
      setSelectedFilters(initialFilters);
      // Optionally, refresh filter options based on the full catalogue
      const responseCatalogue = await getDataFromLocalDb("Catalogue", createQuery(undefined, {}), undefined, productsPerPage, true);
      const responseFilterOptions = getFilterOptionsUnique(responseCatalogue?.data, newFiltersConfig as (keyof Catalogue)[]);
      setFilterOptions(responseFilterOptions);
    }
      setSelectedButton(type);
    }
  }

  const toggleShowListView = () => {
  setShowListView((prev) => {
    if (prev) setCurrentPage(1); 
    return !prev;
  });
};

useEffect(() => {
  const handleScrollEnd = () => {
    if (setScrollTop && scrollRef.current) {
      const scrollTopValue = scrollRef?.current.getScrollElement()?.scrollTop;
      setScrollTop(scrollTopValue || 0);
    }
  }
  
  const el = scrollRef.current?.getScrollElement();
  if (el) {
    el.addEventListener("scrollend", handleScrollEnd)
  }

  return () => {
    if (el) {
      el.removeEventListener("scrollend", handleScrollEnd);
    }
  };
}, [setScrollTop, expandForm]);

const orderInvoiceEditing = sessionStorage.getItem("addMorePressedWhileEditing")
useEffect(() => {
  const handleKeyDown = (event: KeyboardEvent) => {
    // Check if Ctrl (or Cmd on Mac) + A is pressed
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'a') {
      // Prevent default select-all behavior
      event.preventDefault();

      // Only trigger if not focused on an input or textarea
      const activeElement = document.activeElement;
      if (
        activeElement?.tagName !== 'INPUT' &&
        activeElement?.tagName !== 'TEXTAREA'
      ) {
        // Trigger the onButtonClick action
        if (orderId) {
          handleOrderUpdate();
        } else {
          handleCheckout();
        }
      }
    }
  };

  // Add event listener for keydown
  window.addEventListener('keydown', handleKeyDown);

  // Cleanup event listener on component unmount
  return () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
}, [orderId, cart, showListView]); // Dependencies: re-run if orderId changes

  useEffect(() => {
    const filterLists = async() => {
      if(fetchPricingBySalesrep && (selectedSalesRep && selectedSalesRep?.length >= 0)) {
        if((selectedOutletCode && selectedOutletCode?.length > 0) && (selectedBeat && selectedBeat?.length > 0)) {
          let outletFilteredSet = beatOutletMap?.[beatDisplayNameToLoginIdMapping?.[selectedBeat]] ?? new Set();
          setFilteredBeatList(Array.from(outletBeatMap?.[selectedOutletCode] ?? [])?.map(node => beatNameMapping?.[node] ?? '-'));
          setFilteredOutletDetails(outletDetails?.filter(o => outletFilteredSet?.has(o?.outletCode)));
          return;
        } else if(selectedOutletCode && selectedOutletCode?.length > 0) {
          setFilteredBeatList(Array.from(outletBeatMap?.[selectedOutletCode] ?? [])?.map(node => beatNameMapping?.[node] ?? '-'));
        } else if(selectedBeat && selectedBeat?.length > 0) {
          let outletFilteredSet = beatOutletMap?.[beatDisplayNameToLoginIdMapping?.[selectedBeat]] ?? new Set();
          setFilteredOutletDetails(outletDetails?.filter(o => outletFilteredSet?.has(o?.outletCode)));
        }
      }
    }
    filterLists()
    }, [selectedSalesRep, selectedOutletCode, selectedBeat, outletBeatMap, beatOutletMap]);

    const outlet: OutletDetails | null =
      filteredOutletDetails?.find((outlet) => outlet.outletCode === selectedCustomerInfo.outletCode) ?? null;

  return (
    <div className="secondary_order_container">
       <ScreenOverlay apply={loading || orderUpdateLoading} />
      {((!catalogueLoaded.current && isOutletDetailsLoaded && !loading && !catalogueLoading && selectedCustomerInfo?.outletCode?.length > 0) || loading || ((fetchPricingBySalesrep && fetchPricingBySalesrep) ? (!orderId && !isOutletDetailsLoaded && (new URLSearchParams(window.location.search).has("salesRep") ? (selectedCustomerInfo?.outletCode?.length === 0 || (selectedCustomerInfo?.beat?.length === 0) ||(selectedSalesRep?.length === 0)) : salesRep !== "null")) : ((filteredOutletDetails?.length === 0 && !isOutletDetailsLoaded) && !orderId))) ? (
        <Loader sx={{ position: "absolute", top: "42%" }} />
      ) : (
        <>
          <CustomGenericModal
            type={genericModalProps?.type}
            message={genericModalProps?.message}
            modalOpen={genericModalProps?.open}
            onClose={() => {setGenericModalProps(initialGenericModalProps)
              navigateBackOnClose && navigate(-1)
            }}
          />
          <Snackbar
              open={snackbarOpen}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              autoHideDuration={5000}
              onClose={handleSnackbarClose}
            >
              <Alert
                onClose={handleSnackbarClose}
                severity="info"
                sx={{ width: "100%" }}
              >
               Outlet approval is in progress. Please note that only one order can be created for this outlet until approval is completed.
              </Alert>
            </Snackbar>
          {orderId ? (
            <div className="formheaderContainer">
              <FormHeader
                parentLabel = {`${orderInvoiceEditing ? `Edit ${orderStatusInvoiced ? "Invoice" : "Order"}` : `${orderStatusInvoiced ? "Invoice" : "Order"} Details`}`}
                label = {"Add More"}
                goBackToParent={async () => {
                  await resetCart()
                  if (batchIdCatalogue){
                   navigate(`/dashboard/sale/manageInvoices/viewInvoice/${orderId}` as To, {
                    state: {
                      isEditing: isEditing,
                      aggregateStockSummaryMap, isPartialOrder
                    }})
                  } else navigate(-1)
                  }
                }
              />
            </div>
          ) : (
            <SelectCustomer
              beatNameToIdMap={beatDisplayNameToLoginIdMapping}
              beatRecord={beatOutletMap}
              routeIdNameMap={beatNameMapping}
              routeIdDetails={routeIdNameMappingRef.current}
              setFilteredBeats={setFilteredBeatList}
              setSelectedBeat={setSelectedBeat}
              selectedBeat={selectedBeat}
              createSecondaryOrderConfig={createSecondaryOrderConfig.current}
              orderType={orderTypes.current}
              selectedCustomerInfo={selectedCustomerInfo}
              setSelectedCustomerInfo={setSelectedCustomerInfo}
              outletsList={filteredOutletDetails}
              allOutletsList={outletDetails}
              beatList={filteredBeatList}
              expandForm={expandForm}
              setExpandForm={setExpandForm}
              salesReps={salesReps}
              salesRepDisplayNameToLoginIdMapping={salesRepDisplayNameToLoginIdMapping}
              selectedSalesRep={selectedSalesRep}
              setSelectedSalesRep={setSelectedSalesRep}
              setOutletDetails={setFilteredOutletDetails}
              setIsCounterSaleOrder={setIsCounterSaleOrder}
              isCounterSaleOrder={isCounterSaleOrder}
              setOutletApprovalSent={setOutletApprovalSent}
              orderFullfillmentTime={orderFullfillmentTime.current}
              setOutletReferenceId={setOutletReferenceId}
              setSelectedOutletCode={setSelectedOutletCode}
              selectedOutletCode={selectedOutletCode}
            />
          )}
          {((fetchPricingBySalesrep && fetchPricingBySalesrep) ? (((!selectedSalesRep || selectedSalesRep?.length === 0 ) || selectedCustomerInfo?.outletCode?.trim()?.length === 0|| selectedCustomerInfo?.beat?.trim()?.length === 0 || (!orderId && !outlet))) : !selectedCustomerInfo?.outletCode) ? (
            <div className="select_customer_image_container">
              <img
                alt={(fetchPricingBySalesrep && fetchPricingBySalesrep) ? "Please select Sales Rep and Customer to View Product Catalogue" : "Select Customer to View Product Catalogue"}
                src={selectCustomerImage}
                style={{ width: "150px", height: "auto" }}
              />
              <span
                style={{
                  fontSize: "14px",
                  color: "#484848",
                  marginBottom: "3%",
                  marginTop: "5px",
                }}
              >
              {(fetchPricingBySalesrep && fetchPricingBySalesrep) ? "Please select Sales Rep, Route and Customer to View Product Catalogue" : "Select Customer to View Product Catalogue"}
              </span>
            </div>
          ) : 
          catalogueLoading ? (
            <Loader />
          ) :
           (
            <div className="secondary_order_child_container" onWheel={ (e) => handleScrollCSO(e, setExpandForm, scrollTop)}>
            {(!oneClickOrderConfig.isAllowed || (oneClickOrderConfig.isAllowed && orderId)) && (
              <DefaultHeading
                createSecondaryOrderHeading={true}
                heading={"Select Products (" + totalNumberOfProducts + ")"}
                disclaimerText={ConfigDictionary.uomConversion ? "UOM conversion is enabled, stock will be converted to normalised quantity for ordering." : ""}
                disclaimerColor="#cc911f"
                children={
                  <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                     <button className="cso_toggle_button" onClick={toggleShowListView}>
                      {showListView ? <GridViewToggle/> : <ListViewToggle/>}
                     </button>
                  <div className="create-secondary-order-search-bar">           
                    <Search
                      searchFunction={(value) =>
                        setSearchedValue(value?.toLocaleLowerCase()?.replace(/\s+/g, ""))
                      }
                      insideCreateSecondaryOrder={true}
                    />
                  </div>
                  </div>
                }
              /> 
            )}
        <div className="create_secondary_order_catalog" style={oneClickOrderConfig.isAllowed ? {} : {display: "none"}}>
        {oneClickOrderConfig.isAllowed && !orderId && (<div className="product_toggle_type">
              <CustomButton
                backgroundColor={selectedButton === "one-click" ? "#f3fcfb" : "#f5f5f5"}
                borderColor={selectedButton === "one-click" ? "#00bfa5" : "#f5f5f5"}
                fontColor={selectedButton === "one-click" ? "#24c6b1" : "#7C7C7C"}
                fontWeight={selectedButton === "one-click" ? 500 : 300}
                fontSize={"18px"}
                flexGrow={1}
                width={"250px"}
                onClick={() => handleToggleSelectedButton("one-click")}
              >
                One click order
              </CustomButton>

              <CustomButton
                backgroundColor={selectedButton === "all-products" ? "#f3fcfb" : "#f5f5f5"}
                borderColor={selectedButton === "all-products" ? "#00bfa5" : "#f5f5f5"}
                fontColor={selectedButton === "all-products" ? "#24c6b1" : "#7C7C7C"}
                fontWeight={selectedButton === "all-products" ? 500 : 300}
                fontSize={"18px"}
                flexGrow={1}
                width={"250px"}
                onClick={() => handleToggleSelectedButton("all-products")}
              >
                All products
              </CustomButton>
          </div> )}
          {oneClickOrderConfig.isAllowed && !orderId && (
            selectedButton === "one-click" ? (
              <CustomButton
                width="185px"
                height="41px"
                backgroundColor="#2B82A1"
                borderRadius="8px"
                fontColor="#ffffff"
                fontWeight={450}
                onClick={async () => {
                  if (isProcessing) return;

                  setIsProcessing(true);

                  if (addSuggestedQtyState === 1) {
                    setSelectedButton("all-products");
                  } else {
                    setAddSuggestedQtyState(1);

                    oneClickProductUIList.forEach(product => {
                      const { batchCode, suggestedCaseQuantity, suggestedOtherQuantity, suggestedQuantity } = product;

                      const quantities = {
                        caseQuantity: suggestedCaseQuantity ?? 0,
                        otherUnitQuantity: suggestedOtherQuantity ?? 0,
                        pieceQuantity: suggestedQuantity ?? 0,
                      };

                      updateMultiQtyInCart(batchCode, quantities, selectedCustomerInfo, catalogueOneClick, setCart);
                    });
                  }

                  setIsProcessing(false);
                }}
              >
              <div className="CreateSecondaryOrderCartWithPlus">
                <RenderSvg name='CartWithPlus' />
                <span>{ addSuggestedQtyState === 1 ? "Add more products" : "Add Suggested Qty"}</span>
              </div>
              </CustomButton>
            ) : (
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                              <button className="cso_toggle_button" onClick={toggleShowListView}>
                                {showListView ? <GridViewToggle/> : <ListViewToggle/>}
                              </button>
                              <div className="secondary-order-search-bar">
                                <Search
                                  searchFunction={(value) =>
                                    setSearchedValue(value?.toLowerCase()?.replace(/\s+/g, ""))
                                  }
                                />
                              </div>
                            </div>             
            ))
          }
          </div>
            <SimpleBar ref={scrollRef}  style={{height: "100%", scrollbarWidth: "none", overflowY: orderId ? "scroll" : (expandForm ? "hidden" : "scroll")}}>
            <div style={{width: "100%", flexGrow: 1}}>
            {(selectedButton === "all-products" || !(selectedButton === "one-click" && !orderId)) && (
              <CatalogueFiltersNew
                filterOptions={filterOptions}
                updateFilterSelection={updateFilterSelection}
                selectedFilters={selectedFilters}
                filtersConfig={newFiltersConfig}
              />
            )}
              {productLoading ? (
                <Loader />
              ) : (
                <>
                {
                  ((allProductUIList && allProductUIList.length > 0 && selectedButton === "all-products") || (oneClickProductUIList && oneClickProductUIList.length > 0 && selectedButton === "one-click") ? (
                    <div className={showListView ? `secondary_catalogue_container_takeAllSpace` : `secondary_catalogue_container`}>
                      <div
                        className={showListView ? `secondary_catalogue_container_listView`: `select-product`}
                        style={
                          (!showListView && ConfigDictionary.otherUnitLabel)
                            ? { gridTemplateColumns: "repeat(5, minmax(19%, 1fr))" }
                            : {}
                        }
                      >
                      {((selectedButton === "one-click" && !orderId)
                          ? (() => {
                              const paginatedOneClickProductUIList = [];
                              for (let i = 0; i < oneClickProductUIList.length; i += productsPerPage) {
                                paginatedOneClickProductUIList.push(oneClickProductUIList.slice(i, i + productsPerPage));
                              }
                              return paginatedOneClickProductUIList[currentPageOneClick - 1] || [];
                            })()
                          : allProductUIList
                        ).map((productUI: ProductUI) => (
                        <CatalogueProductCard
                          key={productUI.batchCode}
                          productUI={productUI}
                          updateQuantityInCart={updateQuantityInCart}
                          orderType={OrderType.SECONDARY}
                          handleClickViewSkuDetails={handleClickViewSkuDetails}
                          customerInfo={selectedCustomerInfo}
                          setCart={setCart}
                          catalogue={(selectedButton === "one-click" && !orderId) ? catalogueOneClick : catalogue}
                          addSuggestedQtyState={(selectedButton === "one-click" && !orderId) ? addSuggestedQtyState : undefined}
                          setAddSuggestedQtyState={(selectedButton === "one-click" && !orderId) ? setAddSuggestedQtyState : undefined}
                          cartProductMap={cartProducts}
                          oneClickOrderConfig={oneClickOrderConfig}
                          disableStockCheck={disableStockCheck.current}
                          enableMOQCheck = {enableMOQCheck}
                          showListView={showListView}
                        />
                      ))}
                      </div>

                      {!showListView && 
                      <div
                        style={{
                          width: "100%",
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex",
                          marginBottom: "10px",
                        }}
                      >
                      {(selectedButton === "one-click" && !orderId) ? (
                        <Pagination
                          count={Math.ceil(totalNumberOfOneClick / productsPerPage)}
                          page={currentPageOneClick}
                          onChange={(event, page) => setCurrentPageOneClick(page)}
                          variant="outlined"
                          color="primary"
                        />) : (
                        <Pagination
                          count={Math.ceil(totalNumberOfProducts / productsPerPage)}
                          page={currentPage}
                          onChange={(event, page) => setCurrentPage(page)}
                          variant="outlined"
                          color="primary"
                        />)}
                      </div>
                      }
                    </div>
                  ) : 
                   (
                      showNoProductFound && selectedButton === "all-products" ? (
                        <div
                          style={{
                            width: "100%",
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            flex: 1,
                          }}
                        >
                          <div className="CreateSecondaryOrder_noProductsFoundContainer">
                            <NoProducts style={{ height: "150px", width: "150px" }} />
                            <p>No products found</p>
                          </div>
                        </div>
                      ) : <></>
                   )
                  )
                }
                </>
              )}
              </div>
            </SimpleBar>


              <CartSummaryFooter
                cartProducts={cartProducts}
                onButtonClick={orderId ? handleOrderUpdate : handleCheckout}
                buttonText={orderId ? `Add to ${orderStatusInvoiced ? `Invoice` : `Order`}` : "Proceed To Cart"}
                endIcon={true}
                loading={orderUpdateLoading}
              />
            </div>
          )}
        </>
      )}
      <NewDiscountModal
        selectedSkuCode={selectedSku?.batchCode}
        skuData={getSkuData()}
        showFooter={false}
        qtyLabel="In Stock"
        showMrpAndPackSize={!hideMrpLabel}
        slabTransformation={false}
      />
    </div>
  );
};

export default CreateSecondaryOrder;
